/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreateLetterBulk {
  recordIds: Array<string>;
  templateId?: string;
  seasonId?: string | null;
  seasonType?: CreateLetterBulkSeasonTypeEnum | null;
  letterType?: CreateLetterBulkLetterTypeEnum;
  numberFormatCountryIso?: string | null;
}
export enum CreateLetterBulkSeasonTypeEnum {
  Unknown = 'Unknown',
  Sog = 'SOG',
  Gbr = 'GBR',
  Merit = 'Merit',
  IncentiveV2 = 'IncentiveV2',
  SpecialPaymentCash = 'SpecialPaymentCash',
  SpecialPaymentEquity = 'SpecialPaymentEquity',
  PositionEvaluation = 'PositionEvaluation',
  Restructuring = 'Restructuring'
}
export enum CreateLetterBulkLetterTypeEnum {
  Other = 'Other',
  AdherenceLetter = 'AdherenceLetter',
  TargetAgreementForm = 'TargetAgreementForm',
  TargetAchievementForm = 'TargetAchievementForm',
  MeritAllocation = 'MeritAllocation',
  SpecialRecognitionLetter = 'SpecialRecognitionLetter',
  RestructuringCalculation = 'RestructuringCalculation',
  RestructuringLetter = 'RestructuringLetter'
}
